// Fetches the current #1 score for a game so a client can show "BEST 12,340 —
// NAME" in the HUD while you play. Cached per game for the session; refreshed
// on demand (e.g. when a game view mounts).

export interface TopScore { name: string; score: number; detail: string; }

const cache = new Map<string, TopScore | null>();

export function cachedBest(gameId: string): TopScore | null {
  return cache.get(gameId) ?? null;
}

export async function fetchBest(gameId: string): Promise<TopScore | null> {
  try {
    const res = await fetch(`/api/leaderboard/${encodeURIComponent(gameId)}?limit=1`);
    if (!res.ok) { cache.set(gameId, null); return null; }
    const data = await res.json();
    const t = data?.top?.[0];
    const v: TopScore | null = t
      ? { name: String(t.name || "?"), score: Number(t.score) || 0, detail: String(t.detail || "") }
      : null;
    cache.set(gameId, v);
    return v;
  } catch {
    cache.set(gameId, null);
    return null;
  }
}

export function fmtScore(n: number): string {
  return Math.floor(n).toLocaleString("en-US");
}
